import React, { Fragment, useMemo } from 'react';

import { JRCAlbumItemProps } from '../types';

import { AlbumOverlay, AlbumRow, AlbumX1Wrapper } from '../styles';
import { AlbumX1 } from './AlbumX1';
import { ALBUM_DEFAULT_MAX_WIDTH, ALBUM_GAP } from '../const';
import { AlbumX2 } from './AlbumX2';

export const AlbumX5 = ({ files, maxWidth = ALBUM_DEFAULT_MAX_WIDTH, onClick }: JRCAlbumItemProps) => {
    const { filesX2, filesX3, count, width, height } = useMemo(() => {
        return {
            width: Math.floor((maxWidth - ALBUM_GAP * 2) / 3),
            height: Math.floor((maxWidth - ALBUM_GAP * 2) / 3),
            filesX2: [...files].splice(0, 2),
            filesX3: [...files].splice(2, 3),
            count: files.length - 5,
        };
    }, [files, maxWidth]);

    return (
        <Fragment>
            <AlbumX2 files={filesX2} maxWidth={maxWidth} onClick={onClick} />
            <AlbumRow>
                {filesX3.map((file, index) => (
                    <AlbumX1Wrapper key={file.uri}>
                        <AlbumX1 files={[file]} maxWidth={width} maxHeight={height} onClick={onClick} />
                        {count && index === 2 ? <AlbumOverlay>+{count}</AlbumOverlay> : <Fragment />}
                    </AlbumX1Wrapper>
                ))}
            </AlbumRow>
        </Fragment>
    );
};
